export const tickerItems = [
  "今日新增 1,284 条资源，均为站内索引条目",
  "「效率软件」专区本周新增 96 款工具",
  "「高分影视」合集收录量突破 16,540 条",
  "「独立游戏」专题已更新至第 12 期",
  "「视频素材」分区新增 310 条公开目录",
];

export const navItems = [
  { label: "首页", href: "#top" },
  { label: "软件", href: "#categories" },
  { label: "电影", href: "#categories" },
  { label: "游戏", href: "#categories" },
  { label: "视频", href: "#categories" },
  { label: "合集", href: "#collections" },
  { label: "更新热榜", href: "#hot" },
  { label: "查找指引", href: "#guide" },
];

export const heroStats = [
  { value: "68,932", label: "资源条目收录" },
  { value: "1,284", label: "今日更新" },
  { value: "12", label: "内容分区" },
  { value: "199", label: "编辑合集" },
];

export const heroIndex = [
  { name: "软件工具", count: "24,180", unit: "款" },
  { name: "影视资源", count: "16,540", unit: "条" },
  { name: "游戏目录", count: "11,302", unit: "款" },
  { name: "视频素材", count: "9,860", unit: "条" },
  { name: "学习资料", count: "4,210", unit: "套" },
  { name: "设计素材", count: "2,840", unit: "套" },
];

export const categoryTabHint = "四大分区 · 可按用途浏览";

export const categories = [
  {
    key: "software",
    name: "软件工具",
    count: "24,180 款",
    desc: "办公、效率、系统与开发工具集中收录，按用途与平台归档，方便一次性横向比较。",
    tags: ["效率办公", "系统工具", "开发辅助", "手机应用"],
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20flat%20lay%20of%20laptop%20keyboard%20and%20floating%20productivity%20app%20icons%20on%20warm%20cream%20paper%20desk%20with%20soft%20daylight%20muted%20vermilion%20and%20gold%20accents%20editorial%20product%20photography%20clean%20composition&width=600&height=440&seq=cat-software-91&orientation=landscape",
  },
  {
    key: "movie",
    name: "影视资源",
    count: "16,540 条",
    desc: "以高分作品、经典片目与纪录片为主，按年份、地区与类型三条线索引，选片不再漫无目的。",
    tags: ["高分电影", "经典老片", "纪录片", "剧集索引"],
    image:
      "https://readdy.ai/api/search-image?query=Film%20strip%20reels%20and%20vintage%20cinema%20ticket%20arranged%20on%20warm%20cream%20background%20with%20soft%20cinematic%20light%20muted%20vermilion%20and%20amber%20accents%20editorial%20still%20life%20minimal%20composition&width=600&height=440&seq=cat-movie-91&orientation=landscape",
  },
  {
    key: "game",
    name: "游戏目录",
    count: "11,302 款",
    desc: "从独立小品到大型作品，按平台、题材与玩法分类，附带版本与容量信息，方便快速筛选。",
    tags: ["独立游戏", "角色扮演", "休闲益智", "动作冒险"],
    image:
      "https://readdy.ai/api/search-image?query=Game%20controller%20and%20colorful%20cartridge%20resting%20on%20warm%20cream%20desk%20with%20soft%20daylight%20muted%20warm%20tones%20minimal%20editorial%20product%20shot%20clean%20background&width=600&height=440&seq=cat-game-91&orientation=landscape",
  },
  {
    key: "video",
    name: "视频素材",
    count: "9,860 条",
    desc: "收纳可公开使用的画面素材、片头模板与音效条目，按主题与时长索引，做内容更省事。",
    tags: ["画面素材", "片头模板", "音效条目", "转场特效"],
    image:
      "https://readdy.ai/api/search-image?query=Camera%20and%20play%20button%20icon%20on%20warm%20cream%20surface%20with%20soft%20daylight%20muted%20vermilion%20accents%20minimal%20editorial%20composition%20clean%20negative%20space&width=600&height=440&seq=cat-video-91&orientation=landscape",
  },
];

export const featured = [
  {
    span: "large",
    tag: "本周主打",
    title: "创意工作台软件合集：从修图到剪辑一次配齐",
    desc: "把影像处理、视频剪辑、音频整理与排版工具放进同一份索引，每一款都标注平台、体积与适用场景，按需取用即可，不用再逐条翻找。",
    meta: "软件工具 · 收录 42 款 · 周更",
    image:
      "https://readdy.ai/api/search-image?query=Top%20down%20editorial%20flat%20lay%20of%20creative%20software%20workspace%20with%20tablet%20stylus%20notebook%20and%20coffee%20on%20warm%20cream%20desk%20soft%20daylight%20muted%20red%20and%20gold%20accent%20minimal%20print%20composition&width=1200&height=820&seq=feat-large-91&orientation=landscape",
  },
  {
    span: "small",
    tag: "影视",
    title: "高分纪录片索引：自然、人文与城市",
    desc: "把口碑靠前的纪录长片整编成一份片单。",
    meta: "影视资源 · 收纳 88 条",
    image:
      "https://readdy.ai/api/search-image?query=Old%20world%20map%20and%20magnifier%20on%20warm%20cream%20table%20soft%20window%20light%20muted%20amber%20accents%20editorial%20still%20life%20documentary%20mood&width=600&height=400&seq=feat-s1-91&orientation=landscape",
  },
  {
    span: "small",
    tag: "游戏",
    title: "独立游戏精选：小而耐玩的十款",
    desc: "体量不大、口碑在线的独立作品清单。",
    meta: "游戏目录 · 收纳 10 款",
    image:
      "https://readdy.ai/api/search-image?query=Small%20arcade%20machine%20model%20on%20warm%20cream%20desk%20soft%20daylight%20muted%20warm%20red%20accents%20minimal%20editorial%20toy%20photography%20clean%20background&width=600&height=400&seq=feat-s2-91&orientation=landscape",
  },
  {
    span: "small",
    tag: "视频",
    title: "片头转场素材：可直接套用的模板",
    desc: "适合短视频与开场动画的转场条目。",
    meta: "视频素材 · 收纳 156 条",
    image:
      "https://readdy.ai/api/search-image?query=Video%20editing%20timeline%20on%20screen%20with%20clapperboard%20on%20warm%20cream%20desk%20soft%20daylight%20muted%20vermilion%20accents%20minimal%20editorial%20composition&width=600&height=400&seq=feat-s3-91&orientation=landscape",
  },
  {
    span: "small",
    tag: "效率",
    title: "桌面整理工具：一眼看清硬盘占用",
    desc: "空间管理与文件归类的实用小工具。",
    meta: "软件工具 · 收录 14 款",
    image:
      "https://readdy.ai/api/search-image?query=Neatly%20foldered%20paper%20documents%20and%20clips%20on%20warm%20cream%20desk%20soft%20daylight%20muted%20olive%20and%20sand%20accents%20minimal%20editorial%20organization%20still%20life&width=600&height=400&seq=feat-s4-91&orientation=landscape",
  },
];

export const hotList = [
  { rank: 1, title: "全能修图工具 2026 版", category: "软件工具", updated: "2 小时前", size: "486 MB", hot: "本周上升 32 位" },
  { rank: 2, title: "高分纪录片片单 · 第 9 期", category: "影视资源", updated: "4 小时前", size: "片单索引", hot: "收藏 1,204" },
  { rank: 3, title: "像素冒险独立游戏合辑", category: "游戏目录", updated: "6 小时前", size: "2.1 GB", hot: "本周新收录" },
  { rank: 4, title: "商务演示模板素材包", category: "设计素材", updated: "9 小时前", size: "1.4 GB", hot: "下载热度高" },
  { rank: 5, title: "无损音频整理工具", category: "软件工具", updated: "12 小时前", size: "128 MB", hot: "编辑推荐" },
  { rank: 6, title: "城市风光镜头素材集", category: "视频素材", updated: "昨天", size: "素材索引", hot: "收藏 862" },
  { rank: 7, title: "经典老片修复版目录", category: "影视资源", updated: "昨天", size: "片单索引", hot: "本周上升 18 位" },
  { rank: 8, title: "开源笔记软件横向对比", category: "软件工具", updated: "2 天前", size: "对比索引", hot: "长评较多" },
];

export const collections = [
  {
    title: "新装机必备",
    subtitle: "从系统工具到常用软件，一次配齐的入门清单",
    count: "收录 36 款",
    edition: "第 07 期",
    image:
      "https://readdy.ai/api/search-image?query=Organized%20toolbox%20and%20digital%20devices%20flat%20lay%20on%20warm%20cream%20desk%20soft%20daylight%20muted%20vermilion%20and%20gold%20accents%20editorial%20minimal%20composition&width=800&height=520&seq=col-1-91&orientation=landscape",
  },
  {
    title: "周末观影计划",
    subtitle: "按心情挑片，高分与经典搭配着看",
    count: "收录 60 条",
    edition: "第 12 期",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20movie%20night%20setup%20with%20projector%20popcorn%20and%20blanket%20on%20warm%20cream%20sofa%20soft%20evening%20light%20muted%20amber%20accents%20editorial%20lifestyle&width=800&height=520&seq=col-2-91&orientation=landscape",
  },
  {
    title: "独立游戏周",
    subtitle: "小体量、高口碑，适合碎片时间体验",
    count: "收录 24 款",
    edition: "第 03 期",
    image:
      "https://readdy.ai/api/search-image?query=Handheld%20game%20console%20and%20headphones%20on%20warm%20cream%20desk%20soft%20daylight%20muted%20olive%20and%20sand%20accents%20minimal%20editorial%20product%20photography&width=800&height=520&seq=col-3-91&orientation=landscape",
  },
];

export const findPath = [
  {
    step: "01",
    title: "先看分区",
    desc: "从软件、电影、游戏、视频四大分区进入，每个分区都有收录量与子标签，先锁定大致范围。",
  },
  {
    step: "02",
    title: "再用索引",
    desc: "分区内按用途、年份、题材或平台排成索引，条目都标注了体量与更新时间，方便横向比对。",
  },
  {
    step: "03",
    title: "最后跟合集",
    desc: "编辑合集会定期整编同类资源，比如「新装机必备」「周末观影计划」，想要成套餐直接从这里取。",
  },
];

export const faqItems = [
  {
    q: "91下载主要收录哪些类型的资源？",
    a: "页面按软件工具、影视资源、游戏目录、视频素材四个大分区组织，另有学习资料与设计素材等小分区，覆盖日常下载里的常见需求。每个分区都会持续更新收录条目。",
  },
  {
    q: "怎么快速找到想要的资源，而不用来回翻？",
    a: "建议先确定分区，再借助分区内的索引标签缩小范围；如果一时没有明确目标，可以直接翻编辑合集，合集按主题整编了同类资源，比逐个浏览更省时间。",
  },
  {
    q: "页面上的更新热榜是怎么排序的？",
    a: "热榜按照近期浏览与收藏热度综合排列，同时标注更新时间与体量信息。它反映的是当下的关注度，适合用来发现最近值得一看的条目。",
  },
  {
    q: "合集和普通分区有什么区别？",
    a: "分区是全量收录的入口，合集中是编辑按主题二次整编的清单，数量更少但更聚焦。想系统了解某类资源时看分区，想快速拿到成组清单时看合集。",
  },
];